import React from "react";
import "./Team.css";
import { Link } from "react-router-dom";
export default function Team() {
  return (
    <section className="team-section">
      <h2>Our Dedicated Team</h2>
      <Link to={"/ceomessage"}>
        <button className="ceo-btn">
          Read a Personal Message From Our CEO
        </button>
      </Link>
    </section>
  );
}
